"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayMode = void 0;
const preact_1 = require("preact");
const Time_1 = require("../Time");
const Game_1 = require("../../Game");
const TimeLine_1 = require("../TimeLine");
const VolumeControl_1 = require("../VolumeControl");
const PlayButton_1 = require("../Buttons/PlayButton");
const PauseButton_1 = require("../Buttons/PauseButton");
const VolumeButton_1 = require("../Buttons/VolumeButton");
const SpeedUpButton_1 = require("../Buttons/SpeedUpButton");
const SpeedDownButton_1 = require("../Buttons/SpeedDownButton");
const SettingsButton_1 = require("../Buttons/SettingsButton");
const VisualSettingsButton_1 = require("../Buttons/VisualSettingsButton");
const FullscreenButton_1 = require("../Buttons/FullscreenButton");
const HelpButton_1 = require("../Buttons/HelpButton");
const Controls_style_1 = require("../Controls.style");
class ReplayMode extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.onPlayClick = () => {
            this.props.game.playAll();
        };
        this.onPauseClick = () => {
            this.props.game.pauseAll();
        };
        this.onSpeedDown = () => {
            this.props.game.speedDownAll();
            this.forceUpdate();
        };
        this.onSpeedUp = () => {
            this.props.game.speedUpAll();
            this.forceUpdate();
        };
        this.onPreviousPov = () => this.props.game.cyclePov(-1);
        this.onNextPov = () => this.props.game.cyclePov(1);
        this.onVolumeClick = () => {
            this.props.game.soundSystem.toggleMute();
        };
        this.onPlayStateChange = () => {
            this.forceUpdate();
        };
    }
    componentDidMount() {
        this.offPlay = this.props.game.player.events.on('play', this.onPlayStateChange);
        this.offPause = this.props.game.player.events.on('pause', this.onPlayStateChange);
        this.offStop = this.props.game.player.events.on('stop', this.onPlayStateChange);
        this.offUpdate = this.props.game.events.on('postupdate', this.onPlayStateChange);
    }
    componentWillUnmount() {
        this.offPlay && this.offPlay();
        this.offPause && this.offPause();
        this.offStop && this.offStop();
        this.offUpdate && this.offUpdate();
    }
    render() {
        const game = this.props.game;
        const player = game.player;
        const playing = game.isPlaybackPlaying();
        const paused = !playing;
        const playbackSpeed = player.speed >= 1
            ? `${player.speed.toFixed(player.speed % 1 === 0 ? 0 : 2)}×`
            : `${player.speed.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')}×`;
        return ((0, preact_1.h)("div", { class: this.props.class },
            (0, preact_1.h)(TimeLine_1.TimeLine, { game: game }),
            (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.buttons },
                (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.left },
                    (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.button, title: "Previous POV (Q)", onClick: this.onPreviousPov }, "\u25C0"),
                    (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.button, title: "Next POV (E)", onClick: this.onNextPov }, "\u25B6"),
                    (0, preact_1.h)(SpeedDownButton_1.SpeedDownButton, { onClick: this.onSpeedDown }),
                    paused || !playing ? ((0, preact_1.h)(PlayButton_1.PlayButton, { onClick: this.onPlayClick })) : ((0, preact_1.h)(PauseButton_1.PauseButton, { onClick: this.onPauseClick })),
                    (0, preact_1.h)(SpeedUpButton_1.SpeedUpButton, { onClick: this.onSpeedUp }),
                    (0, preact_1.h)("span", { class: Controls_style_1.ControlsStyle.playbackSpeed, title: "Playback speed ([ / ])" }, playbackSpeed),
                    (0, preact_1.h)(VolumeButton_1.VolumeButton, { onClick: this.onVolumeClick }),
                    (0, preact_1.h)(VolumeControl_1.VolumeControl, { game: game }),
                    (0, preact_1.h)(Time_1.Time, { game: game })),
                (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.povTitle, title: game.title }, game.mode === Game_1.PlayerMode.FREE ? 'FREE CAMERA' : game.title || 'Unknown player'),
                (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.right },
                    (0, preact_1.h)(HelpButton_1.HelpButton, null),
                    (0, preact_1.h)("div", { class: Controls_style_1.ControlsStyle.mapButton, title: "Toggle minimap (M)", onClick: () => game.toggleMinimap() }, "\u2316"),
                    (0, preact_1.h)(VisualSettingsButton_1.VisualSettingsButton, { game: game }),
                    (0, preact_1.h)(SettingsButton_1.SettingsButton, { game: game }),
                    (0, preact_1.h)(FullscreenButton_1.FullscreenButton, { active: true, root: this.props.root })))));
    }
}
exports.ReplayMode = ReplayMode;
